module.exports = __webpack_public_path__ + "static/media/gy.d9a32624.svg";